(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["framelle-scroll-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('framelle-assembly')) {
  customElements.define('framelle-assembly', class extends HTMLElement {
    connectedCallback() {
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.storageKey = 'framelle-assembly-drag-seen-v1';
      this.returning = false;
      try { this.returning = localStorage.getItem(this.storageKey) === '1'; } catch (_) {}
      this.chapters = [...this.querySelectorAll('.fas__chapter')];
      this.pieces = [...this.querySelectorAll('.fas__piece')];
      this.images = [...this.querySelectorAll('.fas__piece,.fas__final')];
      this.stage = this.querySelector('.fas__stage');
      this.startHint = this.querySelector('.fas__start');
      this.dock = this.querySelector('.fas__dock');
      this.slider = this.querySelector('.fas__slider');
      this.percent = this.querySelector('.fas__percent');
      this.frame = 0;
      this.ready = false;
      this.lastProgress = -1;
      this.remember = () => {
        try { localStorage.setItem(this.storageKey, '1'); } catch (_) {}
      };
      this.steps = {
        top: [.02,.31,14,-100,-28], left: [.05,.35,-115,10,-22],
        bottom: [.10,.39,-12,105,26], right: [.14,.43,115,-8,22],
        canvas: [.43,.66,0,0,-12], stay: [.68,.83,-8,-55,-8],
        co: [.75,.91,-48,28,-18], ol: [.79,.95,48,28,18]
      };
      this.schedule = () => {
        if (!this.frame && this.classList.contains('is-enhanced')) this.frame = requestAnimationFrame(() => this.render());
      };
      this.configure = () => {
        const enhanced = this.ready && !this.returning && !this.motion.matches && innerHeight >= 640;
        this.classList.toggle('is-enhanced', enhanced);
        this.style.setProperty('--fas-top-space',`${Math.min(180,Math.max(0,scrollY+this.getBoundingClientRect().top))}px`);
        this.dock.hidden = !enhanced;
        this.lastProgress = -1;
        this.schedule();
      };
      this.onInput = () => {
        clearTimeout(this.finishTimer);
        this.schedule();
        if (Number(this.slider.value) === 100) {
          this.finishTimer = setTimeout(() => {
            if (!this.isConnected || Number(this.slider.value) !== 100) return;
            const moveFocus = document.activeElement === this.slider;
            this.returning = true;
            this.configure();
            if (moveFocus) this.querySelector('.fsc__heading h2').focus({preventScroll:true});
          },800);
        }
      };
      this.slider.addEventListener('input',this.onInput);
      addEventListener('resize',this.configure,{passive:true});
      this.motion.addEventListener('change',this.configure);
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(e => e.isIntersecting)) {
          this.observer.disconnect();
          this.images.forEach(img => { img.loading = 'eager'; });
          Promise.all(this.images.map(img => img.decode())).then(() => {
            if (!this.isConnected) return;
            this.ready = true;
            this.configure();
          }).catch(() => {});
        }
      },{rootMargin:'900px'});
      this.observer.observe(this);
    }
    render() {
      this.frame = 0;
      if (!this.classList.contains('is-enhanced')) return;
      const p = Number(this.slider.value)/100;
      if (p === this.lastProgress) return;
      this.lastProgress = p;
      this.startHint.hidden = p > .12;
      this.slider.setAttribute('aria-valuetext',`Tablonun oluşumu yüzde ${Math.round(p*100)}`);
      this.percent.textContent = `${Math.round(p*100)}%`;
      this.style.setProperty('--progress',p);
      if (p >= .995) this.remember();
      this.style.setProperty('--final-opacity',Math.max(0,Math.min(1,(p-.95)/.045)));
      this.style.setProperty('--assembly-turn',`${-5*(1-p)}deg`);
      this.style.setProperty('--guide-opacity',Math.max(0,1-p*1.4));
      this.pieces.forEach(img => {
        const [start,end,x,y,angle] = this.steps[img.dataset.piece];
        const t = Math.max(0,Math.min(1,(p-start)/(end-start)));
        const ease = t*t*(3-2*t);
        img.style.setProperty('--piece-x',`${x*(1-ease)}%`);
        img.style.setProperty('--piece-y',`${y*(1-ease)}%`);
        img.style.setProperty('--piece-turn',`${angle*(1-ease)}deg`);
        img.style.setProperty('--piece-opacity',Math.min(1,t*5));
        img.style.setProperty('--piece-scale',img.dataset.piece==='canvas' ? .35+.65*ease : 1);
      });
      const phase = p < .39 ? 0 : p < .68 ? 1 : 2;
      this.chapters.forEach((chapter,i) => {
        chapter.style.setProperty('--chapter-opacity',i===phase ? 1 : 0);
        chapter.style.setProperty('--chapter-y',i===phase ? '0px' : '12px');
      });
    }
    disconnectedCallback() {
      removeEventListener('resize',this.configure);
      this.motion.removeEventListener('change',this.configure);
      this.slider.removeEventListener('input',this.onInput);
      clearTimeout(this.finishTimer);
      this.observer.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
if (!customElements.get('framelle-showcase')) {
  customElements.define('framelle-showcase', class extends HTMLElement {
    connectedCallback() {
      this.track=this.querySelector('.fsc__track');
      this.slides=[...this.querySelectorAll('.fsc__slide')];
      this.counter=this.querySelector('.fsc__counter');
      this.arrows=[...this.querySelectorAll('.fsc__arrow')];
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      this.active=Math.max(0,this.slides.findIndex(s=>s.dataset.featured==='true'));
      this.abort=new AbortController();
      const options={signal:this.abort.signal};
      this.center=(i,behavior='smooth')=>{
        if (!this.slides.length) return;
        const slide=this.slides[Math.max(0,Math.min(i,this.slides.length-1))];
        this.track.scrollTo({left:slide.offsetLeft+slide.offsetWidth/2-this.track.clientWidth/2,behavior:this.motion.matches?'instant':behavior});
      };
      this.update=()=>{
        this.frame=0;
        if (!this.track.clientWidth) return;
        const middle=this.track.scrollLeft+this.track.clientWidth/2;
        let index=0,distance=Infinity;
        this.slides.forEach((slide,i)=>{
          const delta=Math.abs(slide.offsetLeft+slide.offsetWidth/2-middle);
          if(delta<distance){distance=delta;index=i;}
        });
        this.active=index;
        this.slides.forEach((slide,i)=>{
          slide.classList.toggle('is-active',i===index);
          slide.querySelector('a').tabIndex=i===index?0:-1;
        });
        this.arrows[0].disabled=index===0;
        this.arrows[1].disabled=index===this.slides.length-1;
        clearTimeout(this.announcement);
        this.announcement=setTimeout(()=>{this.counter.textContent=`${String(index+1).padStart(2,'0')} / ${String(this.slides.length).padStart(2,'0')}`;},160);
      };
      this.track.addEventListener('scroll',()=>{if(!this.frame)this.frame=requestAnimationFrame(this.update);},{...options,passive:true});
      this.arrows.forEach(button=>button.addEventListener('click',()=>this.center(this.active+Number(button.dataset.direction)),options));
      this.track.addEventListener('keydown',e=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
        e.preventDefault();
        this.center(e.key==='Home'?0:e.key==='End'?this.slides.length-1:this.active+(e.key==='ArrowRight'?1:-1));
      },options);
      this.track.addEventListener('click',e=>{
        if(this.dragged){e.preventDefault();this.dragged=false;return;}
        const slide=e.target.closest('.fsc__slide');
        if(slide && this.slides.indexOf(slide)!==this.active){e.preventDefault();this.center(this.slides.indexOf(slide));}
      },options);
      this.track.addEventListener('dragstart',e=>e.preventDefault(),options);
      this.track.addEventListener('pointerdown',e=>{
        if(e.pointerType!=='mouse'||e.button!==0)return;
        this.dragged=false;this.pointer={id:e.pointerId,x:e.clientX,left:this.track.scrollLeft};
      },options);
      this.track.addEventListener('pointermove',e=>{
        if(!this.pointer||this.pointer.id!==e.pointerId)return;
        const delta=e.clientX-this.pointer.x;
        if(Math.abs(delta)>5){this.dragged=true;this.track.classList.add('is-dragging');this.track.setPointerCapture(e.pointerId);}
        if(this.dragged)this.track.scrollLeft=this.pointer.left-delta;
      },options);
      const endDrag=e=>{
        if(!this.pointer||this.pointer.id!==e.pointerId)return;
        this.pointer=null;
        if(this.track.hasPointerCapture(e.pointerId))this.track.releasePointerCapture(e.pointerId);
        this.track.classList.remove('is-dragging');
        if(this.dragged){this.update();this.center(this.active);}
      };
      this.track.addEventListener('pointerup',endDrag,options);
      this.track.addEventListener('pointercancel',endDrag,options);
      this.track.addEventListener('pointerleave',e=>{if(!this.dragged)this.pointer=null;},options);
      this.resize=new ResizeObserver(()=>{
        if(!this.track.clientWidth)return;
        this.center(this.active,'instant');this.update();
      });
      this.resize.observe(this.track);
    }
    disconnectedCallback(){this.abort.abort();this.resize.disconnect();cancelAnimationFrame(this.frame);clearTimeout(this.announcement);}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
